import { createApp } from 'vue'
import router from '../router'
import SpaApp from '../SpaApp.vue'
import '../application.css'

// Initialize the SPA
const app = createApp(SpaApp)
app.use(router)
app.mount('#app')